import { Observable } from 'rxjs';
import { QuotationDTO, QuotationRequestDTO, QuotationValidateDTO } from '../../data/dto/QuotationDTO';

export abstract class QuotationRepository {
    abstract getQuotation(request: QuotationRequestDTO): Observable<QuotationDTO>;
    abstract validateQuotation(request: QuotationValidateDTO): Observable<QuotationDTO>;
}
